import React, { useState } from 'react';
import { LoyaltyProgramModal } from './LoyaltyProgramModal';
import { ChevronRightIcon } from 'lucide-react';
interface LoyaltyProgram {
  id: string;
  name: string;
  nameAr: string;
  logo: string;
  color: string;
}
interface LoyaltyPointsSectionProps {
  onPointsApplied: (program: string, amount: number) => void;
  compact?: boolean;
}
export function LoyaltyPointsSection({
  onPointsApplied,
  compact = false
}: LoyaltyPointsSectionProps) {
  const [selectedProgram, setSelectedProgram] = useState<LoyaltyProgram | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const loyaltyPrograms: LoyaltyProgram[] = [{
    id: 'tamayouz',
    name: 'Tamayouz',
    nameAr: 'Tamayouz',
    logo: 'https://cdn.magicpatterns.com/uploads/mocHwPJB59ZpopsC34bv97/Screenshot_74.png',
    color: 'bg-slate-900'
  }, {
    id: 'qitaf',
    name: 'Qitaf',
    nameAr: 'Qitaf',
    logo: 'https://cdn.magicpatterns.com/uploads/b66oBrv6Wq9RhUJGjhhtEZ/Screenshot_73.png',
    color: 'bg-[#4B0082]'
  }, {
    id: 'mokafaa',
    name: 'Mokafaa',
    nameAr: 'Mokafaa',
    logo: 'https://cdn.magicpatterns.com/uploads/gxgNbzagA61hY99WWHu9Lh/images_(2).png',
    color: 'bg-[#2433F5]'
  }];
  const handleProgramClick = (program: LoyaltyProgram) => {
    setSelectedProgram(program);
    setModalOpen(true);
  };
  return <>
      <div className={compact ? 'rounded-lg bg-white p-3 shadow-sm' : 'bg-white rounded-lg shadow-sm p-4 md:p-6'} data-id="element-1643" data-mp="2pvh1itzw3jr4">
        <div className={compact ? 'flex items-center gap-3' : 'block'} data-id="element-1644" data-mp="2luovsaq87wzl">
          <h2 className={compact ? 'shrink-0 text-sm font-bold text-gray-900' : 'text-base md:text-lg font-bold mb-4'} data-id="element-1645" data-mp="2h2drkvogdp18">Use Points</h2>
          <div className={compact ? 'grid min-w-0 flex-1 grid-cols-3 gap-2' : 'grid grid-cols-3 gap-3 md:gap-4'} data-id="element-1646" data-mp="2c313y8prcdxl">
            {loyaltyPrograms.map(program => <button key={program.id} onClick={() => handleProgramClick(program)} className={compact ? 'flex h-9 min-w-0 items-center justify-center rounded-md border border-gray-200 bg-white px-2 transition-colors duration-150 hover:border-brand hover:bg-brand-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand' : 'border-2 border-gray-200 rounded-lg p-3 md:p-4 hover:border-[#1E2B55] transition-colors flex flex-col items-center justify-center gap-2 min-h-[80px] md:min-h-[100px]'} aria-label={`Use ${program.name} points`} data-id="element-1647" data-mp="34rybbgsfkqbk">
                {compact ? <img src={program.logo} alt={program.name} className="h-4 max-w-full object-contain" data-id="element-1648" data-mp="39yn0fjh04rcr" /> : <><div className="text-sm md:text-base font-bold text-[#1E2B55] text-center" data-id="element-1649" data-mp="2vz58wwcbmzzp">{program.nameAr}</div><div className="text-xs text-gray-500" data-id="element-1650" data-mp="2zzo14ri4m82f">{program.name}</div></>}
              </button>)}
          </div>
        </div>
      </div>
      {selectedProgram && <LoyaltyProgramModal isOpen={modalOpen} onClose={() => {
      setModalOpen(false);
      setSelectedProgram(null);
    }} program={selectedProgram} onPointsApplied={onPointsApplied} data-id="element-1651" data-mp="y6rhwhe2bz78" />}
    </>;
}